import React, { FC, Fragment } from 'react';
import { DraftStatus } from 'api/Responses/SetResponses';
import { ReactComponent as CheckMark } from 'assets/CheckMark.svg';
import { helpers } from 'pages/Set/machines/ApprovalWorkflow/machine';
import * as Styles from '../BreadCrumbs.styles';

interface CrumbProps {
  numLabel: string;
  textLabel: string;
  currentStatus: DraftStatus;
  componentStatus: DraftStatus;
  renderLine?: boolean;
}

const stepIsComplete = (currentStatus: DraftStatus, componentStatus: DraftStatus) => {
  const currentState = helpers.mapDraftStatusToMachineState(currentStatus);
  const componentState = helpers.mapDraftStatusToMachineState(componentStatus);

  switch (componentState) {
    case DraftStatus.DRAFT:
      return (
        currentState === DraftStatus.DRAFT ||
        currentState === DraftStatus.REVIEW ||
        currentState === DraftStatus.PENDING ||
        currentState === DraftStatus.MERGED
      );
    case DraftStatus.REVIEW:
      return (
        currentState === DraftStatus.REVIEW ||
        currentState === DraftStatus.PENDING ||
        currentState === DraftStatus.MERGED
      );
    case DraftStatus.PENDING:
      return currentState === DraftStatus.PENDING || currentState === DraftStatus.MERGED;
    case DraftStatus.MERGED:
      return currentState === DraftStatus.MERGED;
    default:
      return false;
  }
};

const Crumb: FC<CrumbProps> = ({ currentStatus, componentStatus, renderLine, numLabel, textLabel }) => {
  return (
    <Fragment>
      <Styles.CrumbContainer complete={stepIsComplete(currentStatus, componentStatus)}>
        <Styles.CrumbNumber className="crumb-number">
          {stepIsComplete(currentStatus, componentStatus) ? <CheckMark title="Complete" /> : numLabel}
        </Styles.CrumbNumber>
        <Styles.CrumbText className="crumb-text">{textLabel}</Styles.CrumbText>
      </Styles.CrumbContainer>

      {renderLine !== false && <Styles.CrumbLine complete={stepIsComplete(currentStatus, componentStatus)} />}
    </Fragment>
  );
};

export default Crumb;
